<template>
  <aside v-if="hasReasons || blocked" class="screening-review-notice" :class="{ compact }" role="note">
    <section v-for="group in groups" :key="group.title" class="contraindication-group">
      <strong>{{ group.title }}</strong>
      <ul><li v-for="(item, index) in group.items" :key="index"><span>{{ item.reason }}</span><small v-if="item.answerSummary">填写信息：{{ item.answerSummary }}</small></li></ul>
    </section>
    <p v-if="blocked" class="screening-action-note">{{ message }}</p>
  </aside>
</template>

<script>
import { isScreeningPassed, screeningStatus, contraindicationItems } from './pc/customer-data';

export default {
  name: 'ScreeningReviewNotice',
  props: { qualified: { type: [Number, String], default: null }, record: { type: Object, default: null }, compact: Boolean },
  computed: {
    context() { return this.record || { qualified: this.qualified }; },
    blocked() { return !isScreeningPassed(this.context); },
    groups() { return [
      { title: '绝对禁忌', items: contraindicationItems(this.context.absoluteContraindications) },
      { title: '相对禁忌', items: contraindicationItems(this.context.relativeContraindications) },
    ].filter(group => group.items.length); },
    hasReasons() { return this.groups.length > 0; },
    message() {
      const status = screeningStatus(this.context);
      if (status === 'PENDING_CONFIRMATION') return '初筛待确认，不能审核通过。请联系我司进行进一步医学确认。';
      if (status === 'REJECTED') return this.hasReasons ? '初筛未通过，不能审核通过。请联系我司进行进一步医学确认。' : '初筛未通过，原记录暂无分类禁忌明细。请联系我司核实，不能审核通过。';
      return '初筛结果缺失或异常，不能审核通过。请刷新核实或联系我司。';
    },
  },
};
</script>

<style scoped>
.screening-review-notice { margin: 10px 0; padding: 10px 12px; border: 1px solid #f0d6a2; border-radius: 6px; background: #fff8e9; color: #87571c; font-size: 13px; font-weight: 500; line-height: 1.65; text-align: left; white-space: normal; }
.screening-review-notice.compact { margin: 6px 0 0; padding: 0; border: 0; background: transparent; font-size: 12px; }
.is-pc .screening-review-notice { margin: 10px 0; padding: 10px 12px; border-width: 1px; border-radius: 6px; font-size: 13px; }
.is-pc .screening-review-notice.compact { margin: 6px 0 0; padding: 0; border: 0; font-size: 12px; }
.contraindication-group + .contraindication-group { margin-top: 8px; }
.contraindication-group ul { margin: 4px 0 0; padding-left: 16px; }
.contraindication-group li + li { margin-top: 5px; }
.contraindication-group small { display: block; font-size: inherit; color: #64788a; }
.screening-action-note { margin: 8px 0 0; }
.is-pc .contraindication-group + .contraindication-group { margin-top: 8px; }
.is-pc .contraindication-group ul { margin-top: 4px; padding-left: 16px; }
.is-pc .contraindication-group li + li { margin-top: 5px; }
.is-pc .screening-action-note { margin-top: 8px; }
</style>
